<autocomplete-list-item (clicked)="triggerEvent()">
  <div class="header">{{ item.name }}</div>
  <div>{{ item.address }}</div>
  <div>{{ item.postalCode }} {{ item.city }}</div>
</autocomplete-list-item>
